module.exports = __webpack_public_path__ + "media/application/images/ui/fake-credit-card-payment-form-alternative-cd1ca4789d6c3c9202327832eb99ae8a.png";